angular.module('common.footer', []).controller('FooterCtrl', ["$scope", function($scope){}]);



// WEBPACK FOOTER //
// ./client/src/app/common/footer/footer.js